import { useEffect, useState } from 'react';

interface AnalysisScreenProps {
  status: 'idle' | 'uploading' | 'completed' | 'failed';
  error?: string | null;
  onNext: () => void;
}

export default function AnalysisScreen({ status, error, onNext }: AnalysisScreenProps) {
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const iv = setInterval(() => {
      setScale((s) => (s === 1 ? 1.08 : 1));
    }, 1400);
    return () => clearInterval(iv);
  }, []);

  return (
    <div
      className="flex flex-col w-full h-screen items-center justify-center"
      style={{
        background: 'linear-gradient(170deg, #1A1B2E 0%, #2D1B3D 60%, #1F1A35 100%)',
        overflow: 'hidden',
      }}
    >
      {/* Pulsing orb */}
      <div style={{ position: 'relative', width: '140px', height: '140px', marginBottom: '48px' }}>
        {[0, 1, 2].map((i) => (
          <div
            key={i}
            style={{
              position: 'absolute',
              top: '50%', left: '50%',
              transform: `translate(-50%, -50%) scale(${scale + i * 0.15})`,
              width: '100px', height: '100px',
              borderRadius: '50%',
              border: `2px solid rgba(62,207,160,${0.5 - i * 0.15})`,
              transition: 'transform 1.2s ease-in-out',
              pointerEvents: 'none',
            }}
          />
        ))}
        <div
          style={{
            position: 'absolute',
            top: '50%', left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '64px', height: '64px',
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(62,207,160,0.6) 0%, rgba(74,144,226,0.3) 100%)',
          }}
        />
        <div
          className="absolute inset-0 flex items-center justify-center"
          style={{ transform: `scale(${scale})`, transition: 'transform 1.2s ease-in-out' }}
        >
          <i className="ri-brain-line text-3xl" style={{ color: '#3ECFA0' }} />
        </div>
      </div>

      {/* Text */}
      <div className="px-8" style={{ maxWidth: '340px', textAlign: 'center' }}>
        {status === 'failed' ? (
          <>
            <p style={{ fontSize: '18px', fontWeight: 500, color: '#F5F5F7', lineHeight: 1.6, marginBottom: '8px' }}>
              Анализ пока не получился.
            </p>
            <p style={{ fontSize: '17px', fontWeight: 400, color: '#A8B2C8', lineHeight: 1.6 }}>
              {error || 'Мы покажем, где можно попробовать записать воспоминание ещё раз.'}
            </p>
          </>
        ) : (
          <>
            <p style={{ fontSize: '18px', fontWeight: 500, color: '#F5F5F7', lineHeight: 1.6, marginBottom: '8px' }}>
              {status === 'completed'
                ? 'Омут Памяти уже разобрал ваше воспоминание.'
                : 'Пока Омут Памяти анализирует ваше воспоминание,'}
            </p>
            <p style={{ fontSize: '17px', fontWeight: 400, color: '#A8B2C8', lineHeight: 1.6 }}>
              {status === 'completed'
                ? 'Мы быстро покажем, что вас ждёт дальше.'
                : 'мы быстро покажем, что вас ждёт дальше.'}
            </p>
          </>
        )}
      </div>

      {/* Button */}
      <div
        className="absolute bottom-0 left-0 right-0 px-7"
        style={{ paddingBottom: 'calc(32px + env(safe-area-inset-bottom))' }}
      >
        <button
          onClick={onNext}
          className="w-full active:scale-95 transition-transform duration-150"
          style={{
            height: '56px',
            borderRadius: '28px',
            background: 'linear-gradient(135deg, #4A90E2, #357ABD)',
            border: 'none',
            fontSize: '17px',
            fontWeight: 600,
            color: '#fff',
            cursor: 'pointer',
            boxShadow: '0 8px 24px rgba(74,144,226,0.35)',
          }}
        >
          Далее
        </button>
      </div>
    </div>
  );
}
